import { defaultTemplate } from '@/api/daily';
import Cookies from 'js-cookie';

// 模板缓存 - 智能缓存机制
let templateCache = new Map(); // 使用Map支持多用户缓存
let cacheTimestamp = new Map();
const CACHE_DURATION = 2 * 60 * 1000; // 缩短为2分钟缓存，提高数据新鲜度

// 模板配置 - 使用简单的同步结构
export const TEMPLATE_CONFIG = {
    // 默认模板ID，如果未初始化则使用空字符串
    DEFAULT_DAILY_CONTROL_TEMPLATE: '',
    // 配置状态
    _initialized: false,
    _loading: false,
    _error: null
};

// 生成缓存键 - 支持多用户隔离
function getCacheKey() {
    // 可以根据用户ID或其他标识符生成唯一键
    return 'default_template'; // 暂时使用固定键，后续可扩展
}

// 检查缓存是否有效
function isCacheValid() {
    const cacheKey = getCacheKey();
    const cache = templateCache.get(cacheKey);
    const timestamp = cacheTimestamp.get(cacheKey);
    
    return cache && 
           timestamp && 
           (Date.now() - timestamp) < CACHE_DURATION;
}

// 强制清除缓存
export function clearTemplateCache() {
    templateCache.clear();
    cacheTimestamp.clear();
    TEMPLATE_CONFIG._initialized = false;
    initPromise = null;
}

// 配置初始化Promise缓存
let initPromise = null;

// 初始化配置 - 异步但不阻塞导入
export async function initializeTemplateConfig() {
    // 未登录时跳过，避免无意义的 401 请求
    if (!Cookies.get('access')) {
        return TEMPLATE_CONFIG;
    }

    if (initPromise) {
        return initPromise;
    }

    if (TEMPLATE_CONFIG._initialized) {
        return TEMPLATE_CONFIG;
    }

    TEMPLATE_CONFIG._loading = true;
    
    initPromise = new Promise(async (resolve, reject) => {
        try {
            
            const cacheKey = getCacheKey();
            
            // 检查缓存
            if (isCacheValid()) {
                const cachedData = templateCache.get(cacheKey);
                TEMPLATE_CONFIG.DEFAULT_DAILY_CONTROL_TEMPLATE = String(cachedData.data.id);
                TEMPLATE_CONFIG._initialized = true;
                TEMPLATE_CONFIG._loading = false;
                TEMPLATE_CONFIG._error = null;
                resolve(TEMPLATE_CONFIG);
                return;
            }
            
            const response = await defaultTemplate();
            
            if (response && response.data && response.data.id) {
                // 更新缓存
                templateCache.set(cacheKey, response);
                cacheTimestamp.set(cacheKey, Date.now());
                
                TEMPLATE_CONFIG.DEFAULT_DAILY_CONTROL_TEMPLATE = String(response.data.id);
                TEMPLATE_CONFIG._initialized = true;
                TEMPLATE_CONFIG._loading = false;
                TEMPLATE_CONFIG._error = null;
                resolve(TEMPLATE_CONFIG);
            } else {
                throw new Error('默认模板数据获取失败: 响应数据无效');
            }
        } catch (error) {
            TEMPLATE_CONFIG._loading = false;
            TEMPLATE_CONFIG._error = error.message;
            resolve(TEMPLATE_CONFIG);
        }
    });

    return initPromise;
}

// 获取缓存的模板数据 - 避免重复API调用
export function getCachedTemplateData() {
    const cacheKey = getCacheKey();
    
    if (isCacheValid()) {
        return templateCache.get(cacheKey);
    }
    
    return null;
}

// 强制刷新缓存 - 获取最新数据
export async function refreshTemplateCache() {
    clearTemplateCache();
    return await initializeTemplateConfig();
}

// 获取模板ID的安全方法
export function getDefaultTemplateId() {
    if (!TEMPLATE_CONFIG._initialized && !TEMPLATE_CONFIG._loading) {
        // 如果还没初始化，立即开始初始化但不等待
        initializeTemplateConfig().catch(() => {}); // 静默处理错误
    }
    
    return TEMPLATE_CONFIG.DEFAULT_DAILY_CONTROL_TEMPLATE || '';
}

// 检查是否已初始化
export function isTemplateConfigReady() {
    return TEMPLATE_CONFIG._initialized && !!TEMPLATE_CONFIG.DEFAULT_DAILY_CONTROL_TEMPLATE;
}

// 模板类型枚举
export const TEMPLATE_TYPES = {
    DAILY_CONTROL: 'daily_control',
};

// 输入类型枚举 - 完整的四种类型
export const INPUT_TYPES = {
    SELECT: '1',      // 单选下拉
    INPUT: '2',       // 输入框
    MULTIPLE: '3',    // 多选框
    TEXT: '4'         // 文本域
};

// 输入类型标签映射
export const INPUT_TYPE_LABELS = {
    '1': '选择',
    '2': '输入',
    '3': '多选',
    '4': '文本'
};

// 重要性等级
export const IMPORTANCE_LEVELS = {
    LOW: 'low',
    HIGH: 'high'
};